import * as React from "react"
import {Box, Typography} from "@mui/material";

import {TitleWithPopover} from "@components";
import RepricingAutoPriceTooltip from "./Tooltip";
import {useSignal} from "@preact/signals-react";


export default function RepricingTableTitle({ title, numScope, updated, same, increase, decrease }) {
	const isOpen = useSignal(false)

	return <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', gap: 2 }}>
		<TitleWithPopover title={title} />
		{ !!numScope && <Typography variant="caption">
			Products in scope: {numScope}
			<Box component="span" sx={{ ml: 1 }}>
				Nº update products:
				<RepricingAutoPriceTooltip isOpen={isOpen} updated={updated} same={same} decrease={decrease} increase={increase}>
					<Box component="span" sx={{ color: "primary.main", pl: .5, cursor: 'pointer' }} onClick={() => isOpen.value = true}>
						{updated}
					</Box>
				</RepricingAutoPriceTooltip>
			</Box>
		</Typography> }
	</Box>
}